/**
 * Interface representing the props for the shared auth hero block (eyebrow + heading + subtitle).
 * @interface IAuthHeroProps
 * @property {string} eyebrow: Uppercase green tagline rendered above the heading.
 * @property {string} headingLineOne: First word(s) of the main heading.
 * @property {string} headingLineTwo: Trailing word(s) of the main heading.
 * @property {string} subtitle: Optional supporting copy shown below the heading; omitted when empty.
 */
interface IAuthHeroProps {
  eyebrow: string;
  headingLineOne: string;
  headingLineTwo: string;
  subtitle?: string;
}

const AuthHero = ({
  eyebrow,
  headingLineOne,
  headingLineTwo,
  subtitle,
}: IAuthHeroProps) => (
  <>
    <p className="font-bold text-dines-green text-xs uppercase tracking-[0.15em] sm:text-sm">
      {eyebrow}
    </p>
    <h1 className="mt-3 font-bold text-3xl text-white leading-[1.05] tracking-tight sm:text-4xl">
      {headingLineOne} {headingLineTwo}
    </h1>
    {subtitle && (
      <p className="mt-4 text-sm text-white/60 leading-relaxed sm:text-base">
        {subtitle}
      </p>
    )}
  </>
);

export default AuthHero;
